import React from "react";
import Card from "./Card";

export const AdviceWrapper = () => {
  return (
    <div className="wrapper">
      <Card />
    </div>
  );
};
